import { StateProvider } from '@uirouter/angularjs';

export function paymentProcessRoutesConfig( $stateProvider: StateProvider ) {
  $stateProvider
    .state('payment-process', {
      url: '/payment-process?config',
      component: 'paymentProcess',
      resolve: {
        $title: () => 'Payment Process'
      }
    })
    .state('payment-redirect', {
      url: '/payment-redirect?order',
      component: 'paymentRedirect',
      resolve: {
        $title: () => 'Payment Redirect'
      }
    });
}

paymentProcessRoutesConfig.$inject = [
  '$stateProvider'
];



// WEBPACK FOOTER //
// ./app/states_mobile/payment-process/payment-process-routing.ts